import { render, staticRenderFns } from "./OrdersOverview.vue?vue&type=template&id=2bde560a&scoped=true&"
import script from "./OrdersOverview.vue?vue&type=script&lang=js&"
export * from "./OrdersOverview.vue?vue&type=script&lang=js&"
import style0 from "./OrdersOverview.vue?vue&type=style&index=0&id=2bde560a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bde560a",
  null
  
)

export default component.exports